(function () {
  'use strict';

  var AUTO_ADVANCE_MS = 3500;

  var steps = [
    {
      key: '1',
      icon: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M4 9.5V20h16V9.5M3 4h18l-1.5 5.5H4.5zM9.5 20v-5.5h5V20"/></svg>',
      title: 'Elegí tus productos',
      description: 'Explorá el catálogo y encontrá lo que necesitás. Podés filtrar por categoría o usar el buscador.',
      cta: { label: 'Ver catálogo', url: '/collections/catalogo', style: 'secondary' }
    },
    {
      key: '2',
      icon: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M2.5 3.5h2.6l2.3 11.2a1.6 1.6 0 0 0 1.6 1.3h8.4a1.6 1.6 0 0 0 1.6-1.2L21 7.5H6.1"/><circle cx="9.5" cy="20" r="1.3"/><circle cx="17.5" cy="20" r="1.3"/></svg>',
      title: 'Agregá al carrito',
      description: 'Presioná "Agregar al carrito" en cada producto. Cuando termines, revisá el carrito y presioná "Finalizar pedido".'
    },
    {
      key: '3',
      icon: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M4 20h4L19 9a2.8 2.8 0 0 0-4-4L4 16z"/><path d="M13.5 6.5l4 4"/></svg>',
      title: 'Completá tus datos',
      description: 'Ingresá tu nombre, dirección de entrega y elegí el método de envío. Revisá que todo esté correcto para evitar demoras.'
    },
    {
      key: '4',
      icon: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><rect x="2.5" y="5" width="19" height="14" rx="2"/><path d="M2.5 9.5h19M6 15h4"/></svg>',
      title: 'Elegí cómo pagás',
      description: 'Tarjeta de crédito, débito, transferencia bancaria o efectivo en Abitab / Red Pagos. El pago se procesa de forma segura.'
    },
    {
      key: '5',
      icon: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><circle cx="12" cy="12" r="9"/><path d="M8 12.5l2.8 2.8L16.5 9.5"/></svg>',
      title: 'Tu pedido confirmado',
      description: 'Te mandamos un email al instante con los próximos pasos. Si elegiste envío, en Montevideo entregamos el mismo día (comprando antes de las 12:00). Si elegiste retiro, te avisamos cuando tu pedido esté listo en Malvín Sur.'
    }
  ];

  function initMoldarteHowToBuyWidget(container) {
    if (!container || container.dataset.widgetInitialized === 'true') return;

    var panel       = container.querySelector('[data-step-panel]');
    var iconNode    = container.querySelector('[data-step-icon]');
    var titleNode   = container.querySelector('[data-step-title]');
    var descNode    = container.querySelector('[data-step-description]');
    var actionsNode = container.querySelector('[data-step-actions]');
    var progressNode = container.querySelector('.moldarte-how-to-buy__progress');
    var buttons     = Array.prototype.slice.call(container.querySelectorAll('.moldarte-how-to-buy__step'));

    if (!panel || !titleNode || !descNode || !buttons.length) return;

    var currentIndex  = 0;
    var autoTimer     = null;
    var userStopped   = false;

    /* ── Calibrar barra de progreso ── */
    var stepPct = 100 / steps.length;
    if (progressNode) {
      progressNode.style.width = stepPct + '%';
    }

    /* ── Pintar paso ── */
    function paintStep(stepKey) {
      var idx = steps.findIndex(function (s) { return s.key === stepKey; });
      if (idx === -1) return;
      currentIndex = idx;

      var selected = steps[idx];
      panel.classList.add('is-transitioning');

      window.setTimeout(function () {
        if (iconNode)  iconNode.innerHTML  = selected.icon; // íconos fijos de este archivo (no hay entrada de usuario)
        titleNode.textContent = selected.title;
        descNode.textContent  = selected.description;

        /* CTA contextual */
        if (actionsNode) {
          if (selected.cta) {
            actionsNode.innerHTML =
              '<a href="' + selected.cta.url + '" class="moldarte-how-to-buy__cta moldarte-how-to-buy__cta--' + selected.cta.style + '">' +
              selected.cta.label +
              '</a>';
          } else {
            actionsNode.innerHTML = '';
          }
        }

        /* Actualizar tabs */
        buttons.forEach(function (btn, i) {
          btn.classList.toggle('is-active', i === idx);
          btn.classList.toggle('is-complete', i < idx);
          btn.setAttribute('aria-selected', i === idx ? 'true' : 'false');
          btn.setAttribute('tabindex', i === idx ? '0' : '-1'); /* pestañas: una sola parada de Tab */
        });
        if (buttons[idx].id) panel.setAttribute('aria-labelledby', buttons[idx].id);

        /* Barra de progreso: left porcentual para que nunca desborde el contenedor */
        if (progressNode) {
          progressNode.style.left = (idx * stepPct) + '%';
        }

        panel.classList.remove('is-transitioning');
      }, 120);
    }

    /* ── Auto-advance ── */
    function advance() {
      paintStep(steps[(currentIndex + 1) % steps.length].key);
    }

    function startAuto() {
      if (userStopped || autoTimer) return;
      autoTimer = setInterval(advance, AUTO_ADVANCE_MS);
    }

    function stopAuto() {
      clearInterval(autoTimer);
      autoTimer = null;
    }

    /* Click manual */
    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        paintStep(btn.getAttribute('data-step'));
      });
    });

    /* Teclado (patrón de pestañas): ← → recorren, Inicio/Fin van a los extremos; activación automática */
    buttons.forEach(function (btn, i) {
      btn.addEventListener('keydown', function (e) {
        var to = null;
        if (e.key === 'ArrowRight' || e.key === 'Right') to = (i + 1) % buttons.length;
        else if (e.key === 'ArrowLeft' || e.key === 'Left') to = (i - 1 + buttons.length) % buttons.length;
        else if (e.key === 'Home') to = 0;
        else if (e.key === 'End') to = buttons.length - 1;
        if (to === null) return;
        e.preventDefault();
        buttons.forEach(function (b, j) { b.setAttribute('tabindex', j === to ? '0' : '-1'); });
        buttons[to].focus();
        paintStep(buttons[to].getAttribute('data-step'));
      });
    });

    paintStep('1');
    container.dataset.widgetInitialized = 'true';
  }

  window.initMoldarteHowToBuyWidget = initMoldarteHowToBuyWidget;

  document.addEventListener('DOMContentLoaded', function () {
    var widgets = document.querySelectorAll('[data-moldarte-how-to-buy-widget]');
    widgets.forEach(function (widget) {
      initMoldarteHowToBuyWidget(widget);
    });
  });
})();
